enum BUTTON_TYPES {
  CONTAINED = 'CONTAINED',
  OUTLINED = 'OUTLINED',
  TEXT = 'TEXT',
}

export default BUTTON_TYPES;
